var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon2",
    clipPath: "url(#clip0_1892_1703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2551 38.8717C32.2162 40.4059 27.1595 13.2936 27.1595 13.2936C27.1595 13.2936 -0.550908 13.2402 5.0642 34.526C-0.274531 28.0013 -0.434898 18.4047 5.14268 11.665C11.48 4.00634 22.8262 2.93499 30.4852 9.27322C38.1441 15.6114 39.2143 26.9572 32.877 34.6159C27.2539 41.4102 17.6899 43.0195 10.2551 38.8706V38.8717Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.799 19.3506C22.799 19.3506 15.2562 34.9045 2.9043 38.298",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1892_1703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.01,
    height: 44.86,
    fill: "white",
    transform: "translate(0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedElements);
export default __webpack_public_path__ + "static/media/selected-elements.d71d18415aed3b37a14e16d5addd7e27.svg";
export { ForwardRef as ReactComponent };